<template>
  <div>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.name == 'xs'"
      persistent
      v-model="dialog"
      width="700"
    >
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>TRANSFER OLD OPTION</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="body__card">
          <v-text-field
            v-model="search"
            label="Search Option Name TH or EN"
          ></v-text-field>
          <div
            v-for="(option, i) in filterList"
            :key="i"
            class="mt-3 card__content"
          >
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <div class="title__1">
                {{ option.option_name_th
                }}<span v-if="option.option_name_en" class="title__2">
                  {{ `(${option.option_name_en})` }}</span
                >
              </div>
              <div>
                <v-checkbox
                  color="primary"
                  hide-details
                  :value="transferOptionList.includes(option.option_id)"
                  @change="transferOptionList.push(option.option_id)"
                ></v-checkbox>
              </div>
            </div>

            <div>
              <li v-for="(choice, i2) in option.option_choice" :key="i2">
                {{ choice.choice_name_th
                }}<span
                  v-if="choice.choice_name_en"
                  style="font-size: 14px; color: grey"
                >
                  {{ `(${choice.choice_name_en})` }}</span
                >
              </li>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="resetForm()">reset</v-btn>
          <v-btn color="success" @click="submit()">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["dialog"],
  data() {
    return {
      valid: true,
      transferOptionList: [],
      search: "",
    };
  },
  watch: {},
  computed: {
    ...mapState({
      storeOptionV1List: (state) => state.product.storeOptionV1List,
    }),
    filterList() {
      return this.storeOptionV1List.filter((val) => {
        return (
          val.option_name_th
            .toString()
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.option_name_en
            .toString()
            .toLowerCase()
            .includes(this.search.toLowerCase())
        );
      });
    },
  },
  methods: {
    closeDialog() {
      this.transferOptionList = [];
      this.$emit("close");
    },
    validateStart(value, index) {
      if (index == 0) {
        return true;
      } else {
        return (
          value >
          parseFloat(this.form.distance_text[index - 1].transport_charge_end)
        );
      }
    },
    validateEnd(value, index) {
      return (
        value >
        parseFloat(this.form.distance_text[index].transport_charge_start)
      );
    },
    removeCondition(index) {
      if (this.form.distance_text.length > 1) {
        this.form.distance_text.splice(index, 1);
      }
    },
    moreChoice() {
      this.form.option_choice.push({
        choice_name_cn: "",
        choice_name_en: "",
        choice_name_th: "",
        choice_price: 0,
      });
    },

    removeChoice(index) {
      this.form.option_choice.splice(index, 1);
    },

    resetForm() {
      this.transferOptionList = [];
    },
    async submit() {
      this.$emit("save", this.transferOptionList);
      this.transferOptionList = [];
    },
  },
};
</script>

<style scoped>
.body__card--choice {
  border: 1px solid #e6e6e6;
  border-radius: 20px;
  padding: 20px;
}

.body__card {
  height: 70vh;
  overflow: scroll;
}

.card__content {
  border: 1px solid grey;
  padding: 10px;
  border-radius: 20px;
}

.card__content .title__1 {
  font-size: 22px;
  font-weight: bold;
}

.card__content .title__2 {
  font-size: 20px;
  color: grey;
}

.body__card--choice .card__number {
  background-color: black;
  color: white;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 16px;
}

.body__title--choice {
  font-weight: bold;
  font-size: 20px;
}

.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loading-item {
  animation: fade 2s infinite linear;
}
.loading-item-span {
  font-size: 28px;
}

@media screen and (max-width: 788px) {
  .body__card {
    height: 85vh;
  }
}
</style>